var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BackgroundCommand } from '@reference-data/background-message-key.enum';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
/* istanbul ignore next */
const exportSettings = () => __awaiter(void 0, void 0, void 0, function* () {
    const val = yield LocalStorageUtils.getMultipleValueFromLocalStorage([
        LocalStorageKeyEnum.AUTOLOCK,
        LocalStorageKeyEnum.CLAIM_ACCOUNTS,
        LocalStorageKeyEnum.CLAIM_REWARDS,
        LocalStorageKeyEnum.NO_CONFIRM,
        LocalStorageKeyEnum.FAVORITE_USERS,
        LocalStorageKeyEnum.RPC_LIST,
        LocalStorageKeyEnum.KEYCHAINIFY_ENABLED,
        LocalStorageKeyEnum.CURRENT_RPC,
        LocalStorageKeyEnum.SWITCH_RPC_AUTO,
        LocalStorageKeyEnum.HIDDEN_TOKENS,
        LocalStorageKeyEnum.STEEM_ENGINE_ACTIVE_CONFIG,
        LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_ACCOUNT_HISTORY_API,
        LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_RPC_LIST,
    ]);
    var data = new Blob([JSON.stringify(val)], {
        type: 'text/plain',
    });
    var url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'settings.kc';
    a.click();
});
/* istanbul ignore next */
const importSettings = () => __awaiter(void 0, void 0, void 0, function* () {
    chrome.windows.getCurrent((currentWindow) => __awaiter(void 0, void 0, void 0, function* () {
        const win = {
            url: chrome.runtime.getURL('import-preferences.html'),
            type: 'popup',
            height: 600,
            //      width: 435,
            width: 400,
            left: currentWindow.width - 350 + currentWindow.left,
            top: currentWindow.top,
        };
        // Except on Firefox
        //@ts-ignore
        if (typeof InstallTrigger === undefined)
            win.focused = true;
        const window = yield chrome.windows.create(win);
        chrome.runtime.onMessage.addListener(onSettingsUploadSuccessfulListener);
    }));
});
/* istanbul ignore next */
const onSettingsUploadSuccessfulListener = (backgroundMessage, sender, sendResp) => {
    if (backgroundMessage.command === BackgroundCommand.IMPORT_SETTINGS_CALLBACK &&
        backgroundMessage.value === 'html_popup_import_settings_successful') {
        window.close();
        chrome.runtime.onMessage.removeListener(onSettingsUploadSuccessfulListener);
    }
};
const SettingsUtils = {
    exportSettings,
    importSettings,
};
export default SettingsUtils;
